import { useAuth } from '@/hooks/useAuth';
import { Permissions, type Permission } from '@/types';

interface JobTabsProps {
  activeTab: 'overview' | 'job-costs';
  onTabChange: (tab: 'overview' | 'job-costs') => void;
}

export function JobTabs({ activeTab, onTabChange }: JobTabsProps) {
  const { hasPermission } = useAuth();

  const allTabs: { id: 'overview' | 'job-costs'; label: string; permission?: Permission }[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'job-costs', label: 'Job Costs', permission: Permissions.JobsCost },
  ];

  const tabs = allTabs.filter(tab => !tab.permission || hasPermission(tab.permission));

  return (
    <div className="border-b border-border">
      <nav className="flex gap-1" aria-label="Job tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
              activeTab === tab.id
                ? 'bg-white text-secondary border-t-2 border-x border-border border-b-0'
                : 'bg-gray-50 text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            }`}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
